// Generated with Inkscape (export > .html)

export function logoThermix() {
  const canvas  = document.createElement("canvas");
  canvas.width  = 300;
  canvas.height = 300;
  let ctx       = canvas.getContext("2d");

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(134.123440, 70.550370);
  ctx.bezierCurveTo(133.355010, 70.225210, 132.273050, 69.187480, 131.719060, 68.240330);
  ctx.bezierCurveTo(130.731380, 66.551820, 130.735650, 66.479350, 131.937590, 64.500050);
  ctx.bezierCurveTo(132.611660, 63.389860, 134.153160, 61.258190, 135.363090, 59.762820);
  ctx.bezierCurveTo(140.395660, 53.543460, 143.547410, 45.654620, 142.784830, 41.186350);
  ctx.bezierCurveTo(142.305600, 38.377880, 140.333970, 34.848860, 137.877560, 32.402570);
  ctx.bezierCurveTo(133.572820, 28.115550, 131.638730, 23.035830, 131.987180, 16.932090);
  ctx.bezierCurveTo(132.188520, 13.409200, 132.509670, 12.311080, 134.213130, 9.332320);
  ctx.bezierCurveTo(137.905200, 2.874990, 142.729390, -0.427490, 146.245600, 1.095330);
  ctx.bezierCurveTo(150.886190, 3.104830, 151.244390, 6.193450, 147.264730, 9.882540);
  ctx.bezierCurveTo(144.417400, 12.521920, 143.623970, 14.132400, 143.623970, 17.271740);
  ctx.bezierCurveTo(143.623970, 20.633450, 143.955650, 21.320470, 148.544040, 27.469320);
  ctx.bezierCurveTo(153.140480, 33.628710, 154.242090, 36.586470, 154.242090, 42.767790);
  ctx.bezierCurveTo(154.242090, 47.862420, 153.468900, 51.117800, 151.174460, 55.683160);
  ctx.bezierCurveTo(148.407550, 61.188700, 142.188000, 69.108330, 139.813820, 70.149170);
  ctx.bezierCurveTo(137.966750, 70.958820, 135.506580, 71.132550, 134.123570, 70.548660);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(190.941960, 70.384820);
  ctx.bezierCurveTo(188.959790, 69.485050, 187.752080, 67.215890, 188.340680, 65.497370);
  ctx.bezierCurveTo(188.580290, 64.798270, 190.154680, 62.569980, 191.839840, 60.545850);
  ctx.bezierCurveTo(199.011870, 51.930190, 201.622680, 44.059430, 199.209010, 38.330170);
  ctx.bezierCurveTo(198.737000, 37.209300, 196.981460, 34.795670, 195.308170, 32.965850);
  ctx.bezierCurveTo(190.584330, 27.800750, 189.261230, 24.989080, 188.988550, 19.536170);
  ctx.bezierCurveTo(188.737290, 14.513260, 189.332990, 11.797840, 191.467810, 8.234950);
  ctx.bezierCurveTo(193.504620, 4.835620, 197.074650, 1.475630, 199.138850, 1.015440);
  ctx.bezierCurveTo(203.088060, 0.135180, 206.773640, 2.361140, 206.773640, 5.626690);
  ctx.bezierCurveTo(206.773640, 7.136370, 206.327140, 7.878200, 204.222220, 9.863080);
  ctx.bezierCurveTo(201.143650, 12.765840, 200.626330, 13.808220, 200.626330, 17.108420);
  ctx.bezierCurveTo(200.626330, 20.223470, 201.962990, 23.279470, 204.925190, 26.936520);
  ctx.bezierCurveTo(210.502930, 33.822690, 212.096600, 38.072000, 211.650480, 44.868750);
  ctx.bezierCurveTo(211.211750, 51.552450, 207.391830, 59.707120, 201.371840, 66.811160);
  ctx.bezierCurveTo(197.831470, 70.989020, 194.663980, 72.074360, 190.941990, 70.385150);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(77.320485, 70.675890);
  ctx.bezierCurveTo(75.578476, 70.087340, 74.326728, 68.355160, 74.326728, 66.533790);
  ctx.bezierCurveTo(74.326728, 65.359030, 75.151113, 63.958980, 77.484442, 61.170210);
  ctx.bezierCurveTo(84.484198, 52.804220, 87.417410, 44.588230, 85.484848, 38.760920);
  ctx.bezierCurveTo(85.170358, 37.813310, 84.050341, 36.023060, 82.995551, 34.782800);
  ctx.bezierCurveTo(81.940706, 33.542540, 80.151052, 31.393230, 79.018554, 30.006270);
  ctx.bezierCurveTo(71.641703, 20.973430, 73.086799, 9.134580, 82.448382, 1.907770);
  ctx.bezierCurveTo(84.325450, 0.458480, 85.375193, 0.000000, 86.812973, 0.000000);
  ctx.bezierCurveTo(89.069758, 0.000000, 91.236579, 1.308550, 92.197521, 3.251150);
  ctx.bezierCurveTo(93.151252, 5.179360, 92.610185, 6.576160, 89.888875, 9.209230);
  ctx.bezierCurveTo(84.334669, 14.583680, 84.678988, 18.165890, 91.658949, 27.624280);
  ctx.bezierCurveTo(96.175959, 33.745210, 97.239452, 36.631110, 97.239452, 42.767700);
  ctx.bezierCurveTo(97.239452, 49.746030, 95.444861, 54.679940, 90.201102, 62.118520);
  ctx.bezierCurveTo(86.773825, 66.980290, 84.033191, 69.711550, 81.796667, 70.494120);
  ctx.bezierCurveTo(79.711048, 71.223880, 79.024606, 71.251750, 77.320424, 70.675280);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(72.980322, 299.295830);
  ctx.bezierCurveTo(68.639193, 297.909710, 64.692470, 294.849940, 62.293759, 291.010990);
  ctx.lineTo(60.914384, 288.803610);
  ctx.lineTo(60.914384, 204.059660);
  ctx.lineTo(60.914384, 119.315760);
  ctx.lineTo(62.350889, 116.941620);
  ctx.bezierCurveTo(64.127231, 114.005880, 67.884861, 110.889720, 71.392785, 109.443260);
  ctx.bezierCurveTo(75.320084, 107.823960, 83.116993, 107.631180, 87.070572, 109.053070);
  ctx.bezierCurveTo(90.521976, 110.296580, 95.090636, 114.186300, 96.799559, 117.336370);
  ctx.bezierCurveTo(98.009600, 119.566970, 98.018580, 119.811310, 98.515110, 164.150970);
  ctx.bezierCurveTo(98.795210, 189.174890, 98.809080, 226.127770, 98.546010, 248.406850);
  ctx.lineTo(98.077880, 288.090250);
  ctx.lineTo(96.238137, 291.218770);
  ctx.bezierCurveTo(94.223792, 294.644110, 91.387613, 296.990940, 87.256405, 298.650570);
  ctx.bezierCurveTo(83.920591, 299.990700, 76.245940, 300.336300, 72.980423, 299.293920);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(11.376211, 299.057850);
  ctx.bezierCurveTo(7.474759, 297.764180, 3.910138, 295.019350, 1.775532, 291.665170);
  ctx.lineTo(0.000000, 288.875280);
  ctx.lineTo(0.000000, 204.059480);
  ctx.lineTo(0.000000, 119.243720);
  ctx.lineTo(1.775510, 116.453830);
  ctx.bezierCurveTo(5.211661, 111.054710, 11.088311, 108.114050, 18.441950, 108.114050);
  ctx.bezierCurveTo(26.016802, 108.114050, 32.390142, 111.505020, 35.594452, 117.240580);
  ctx.lineTo(37.163353, 120.048590);
  ctx.lineTo(37.442900, 162.053960);
  ctx.bezierCurveTo(37.596539, 185.156910, 37.596539, 222.961760, 37.442900, 246.064720);
  ctx.lineTo(37.163353, 288.070140);
  ctx.lineTo(35.690685, 290.700230);
  ctx.bezierCurveTo(33.699746, 294.256100, 30.708263, 296.910260, 26.959557, 298.446230);
  ctx.bezierCurveTo(22.697856, 300.192340, 15.634058, 300.469660, 11.376184, 299.057530);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(132.726320, 298.697340);
  ctx.bezierCurveTo(129.030480, 297.194170, 124.851200, 293.771190, 122.998330, 290.729540);
  ctx.lineTo(121.828790, 288.809690);
  ctx.lineTo(121.828790, 204.059570);
  ctx.lineTo(121.828790, 119.309490);
  ctx.lineTo(123.008210, 117.373390);
  ctx.bezierCurveTo(124.926760, 114.223970, 129.294530, 110.720490, 133.160900, 109.229910);
  ctx.bezierCurveTo(136.063090, 108.110890, 137.377730, 107.888380, 141.109040, 107.884670);
  ctx.bezierCurveTo(144.869890, 107.880670, 146.080480, 108.084410, 148.732570, 109.176490);
  ctx.bezierCurveTo(152.399790, 110.684770, 155.810870, 113.595900, 157.839510, 116.948590);
  ctx.lineTo(159.271580, 119.315300);
  ctx.lineTo(159.271580, 203.825220);
  ctx.lineTo(159.271580, 288.335100);
  ctx.lineTo(157.839510, 290.701810);
  ctx.bezierCurveTo(155.816510, 294.045400, 152.400720, 296.966040, 148.777740, 298.450550);
  ctx.bezierCurveTo(146.305920, 299.463190, 144.689150, 299.758160, 140.874800, 299.892400);
  ctx.bezierCurveTo(136.497840, 300.045690, 135.786830, 299.943500, 132.726330, 298.697200);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(194.121570, 298.875760);
  ctx.bezierCurveTo(190.270920, 297.373980, 187.014530, 294.825650, 184.675040, 291.482660);
  ctx.lineTo(182.743180, 288.722040);
  ctx.lineTo(182.743180, 203.974290);
  ctx.lineTo(182.743180, 119.226530);
  ctx.lineTo(184.438430, 116.745080);
  ctx.bezierCurveTo(186.829830, 113.244490, 191.612990, 109.715610, 195.209150, 108.798370);
  ctx.bezierCurveTo(200.252910, 107.512130, 205.525140, 107.402500, 208.594870, 108.519660);
  ctx.bezierCurveTo(212.015380, 109.765030, 216.389770, 113.201380, 218.515310, 116.312670);
  ctx.lineTo(220.185940, 118.758340);
  ctx.lineTo(220.185940, 203.582700);
  ctx.lineTo(220.185940, 288.407050);
  ctx.lineTo(218.435390, 291.157450);
  ctx.bezierCurveTo(214.760570, 296.931670, 208.701860, 300.008720, 201.024420, 299.999990);
  ctx.bezierCurveTo(197.954010, 299.996990, 196.309460, 299.730570, 194.121510, 298.875390);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(255, 255, 255)';
  ctx.moveTo(256.035880, 298.162450);
  ctx.bezierCurveTo(254.391380, 297.651480, 252.631010, 296.972830, 252.123940, 296.654630);
  ctx.bezierCurveTo(249.382000, 294.932670, 247.280130, 292.915740, 245.570430, 290.365550);
  ctx.lineTo(243.657590, 287.512490);
  ctx.lineTo(243.657590, 203.144150);
  ctx.lineTo(243.657590, 118.775860);
  ctx.lineTo(245.430660, 115.990150);
  ctx.bezierCurveTo(251.853780, 105.897610, 267.428920, 104.115540, 276.375870, 112.449610);
  ctx.bezierCurveTo(279.512400, 115.371420, 281.099550, 118.910660, 281.103270, 122.991990);
  ctx.bezierCurveTo(281.105270, 124.719990, 281.268550, 128.187100, 281.467120, 130.696880);
  ctx.lineTo(281.828200, 135.260290);
  ctx.lineTo(285.001170, 135.260290);
  ctx.bezierCurveTo(290.075000, 135.260290, 293.623610, 137.590300, 296.968430, 143.118420);
  ctx.bezierCurveTo(299.383070, 147.109080, 300.249330, 151.163050, 299.939670, 157.023530);
  ctx.bezierCurveTo(299.376360, 167.684550, 294.062930, 174.652570, 285.537710, 175.910210);
  ctx.bezierCurveTo(283.625030, 176.193560, 281.929730, 176.532190, 281.770260, 176.665970);
  ctx.bezierCurveTo(281.611080, 176.800680, 281.363140, 201.814940, 281.219490, 232.255810);
  ctx.lineTo(280.958800, 287.602930);
  ctx.lineTo(279.597560, 289.868370);
  ctx.bezierCurveTo(276.272840, 295.401320, 270.416940, 298.639230, 263.217350, 298.925560);
  ctx.bezierCurveTo(260.038170, 299.050980, 258.303920, 298.869860, 256.035980, 298.163290);
  ctx.fill();

  return canvas.toDataURL();
}

export function wonderingSmiley() {
  const canvas  = document.createElement("canvas");
  canvas.width  = 300;
  canvas.height = 300;
  let ctx       = canvas.getContext("2d");

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(241, 135, 0)';
  ctx.moveTo(141.582330, 299.529400);
  ctx.bezierCurveTo(114.136740, 297.821480, 89.412843, 289.603840, 66.917552, 274.712630);
  ctx.bezierCurveTo(36.806757, 254.780170, 14.573843, 223.946560, 5.167291, 189.074570);
  ctx.bezierCurveTo(-0.195129, 169.194970, -1.399929, 148.318620, 1.628001, 127.746860);
  ctx.bezierCurveTo(7.342321, 88.923798, 28.371067, 53.671465, 59.964039, 29.953057);
  ctx.bezierCurveTo(86.838504, 9.777065, 119.485970, -0.734778, 152.867540, 0.039950);
  ctx.bezierCurveTo(165.148410, 0.324968, 174.943030, 1.614460, 186.267200, 4.437117);
  ctx.bezierCurveTo(222.507510, 13.470357, 254.202280, 35.945873, 274.959650, 67.331093);
  ctx.bezierCurveTo(278.402420, 72.536544, 280.762420, 76.622102, 283.717300, 82.492033);
  ctx.bezierCurveTo(292.328530, 99.598401, 297.146860, 116.380480, 299.165110, 136.296260);
  ctx.bezierCurveTo(299.484220, 139.445140, 299.568600, 142.328040, 299.565520, 149.975310);
  ctx.bezierCurveTo(299.561520, 160.328950, 299.382860, 163.119180, 298.194540, 171.405810);
  ctx.bezierCurveTo(291.293370, 219.529360, 261.077910, 261.585580, 217.615010, 283.562580);
  ctx.bezierCurveTo(199.982340, 292.478540, 181.489830, 297.670080, 161.530930, 299.307460);
  ctx.bezierCurveTo(157.560230, 299.633220, 145.420910, 299.768260, 141.582330, 299.529400);
  ctx.moveTo(161.644920, 277.553970);
  ctx.bezierCurveTo(166.218460, 277.041600, 169.354730, 276.570650, 173.386100, 275.790950);
  ctx.bezierCurveTo(201.987160, 270.259080, 228.021020, 254.830230, 246.764640, 232.303540);
  ctx.bezierCurveTo(256.554750, 220.537460, 264.316220, 206.758540, 269.252850, 192.380340);
  ctx.bezierCurveTo(272.544550, 182.793050, 274.562230, 173.401410, 275.669140, 162.514430);
  ctx.bezierCurveTo(276.213890, 157.156860, 276.214890, 144.913820, 275.671140, 139.488040);
  ctx.bezierCurveTo(273.323460, 116.066790, 265.753230, 95.580264, 252.652780, 77.196278);
  ctx.bezierCurveTo(224.358900, 37.491174, 176.536050, 17.577605, 128.245260, 25.392640);
  ctx.bezierCurveTo(78.965581, 33.367711, 38.459751, 70.313065, 25.899154, 118.742490);
  ctx.bezierCurveTo(23.017527, 129.853070, 21.883895, 139.068160, 21.902669, 151.229220);
  ctx.bezierCurveTo(21.917699, 160.962750, 22.473721, 166.907470, 24.184338, 175.623510);
  ctx.bezierCurveTo(29.970156, 205.103780, 46.269262, 231.829290, 69.907880, 250.596000);
  ctx.bezierCurveTo(89.988603, 266.538100, 113.895260, 275.830870, 140.094170, 277.878170);
  ctx.bezierCurveTo(143.921420, 278.177240, 157.967680, 277.965970, 161.644920, 277.553970);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(241, 135, 0)';
  ctx.moveTo(107.545440, 220.458080);
  ctx.bezierCurveTo(103.426010, 218.995650, 101.384460, 214.262320, 103.148220, 210.263140);
  ctx.bezierCurveTo(103.726400, 208.952140, 105.202130, 207.347100, 106.397320, 206.729310);
  ctx.bezierCurveTo(106.857380, 206.491510, 113.423330, 203.945030, 120.988300, 201.070470);
  ctx.bezierCurveTo(145.247300, 191.852480, 160.147080, 186.180890, 175.323970, 180.387630);
  ctx.bezierCurveTo(189.875310, 174.833160, 190.173810, 174.730910, 191.852810, 174.726000);
  ctx.bezierCurveTo(193.860820, 174.720000, 195.144360, 175.210920, 196.629100, 176.552290);
  ctx.bezierCurveTo(198.115740, 177.895380, 198.754730, 179.354220, 198.868580, 181.665090);
  ctx.bezierCurveTo(198.946980, 183.256530, 198.875580, 183.837160, 198.470120, 184.913100);
  ctx.bezierCurveTo(197.873360, 186.496000, 196.178230, 188.429730, 194.785470, 189.116400);
  ctx.bezierCurveTo(194.238330, 189.386160, 183.069730, 193.679360, 169.966340, 198.656850);
  ctx.bezierCurveTo(156.862960, 203.634340, 142.961630, 208.915040, 139.074500, 210.391750);
  ctx.bezierCurveTo(135.187380, 211.868450, 127.492910, 214.799620, 121.975700, 216.905460);
  ctx.bezierCurveTo(113.030310, 220.319790, 111.771640, 220.742510, 110.348510, 220.810450);
  ctx.bezierCurveTo(109.207080, 220.864950, 108.408860, 220.764650, 107.545440, 220.458080);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(241, 135, 0)';
  ctx.moveTo(185.811230, 132.555660);
  ctx.bezierCurveTo(180.282700, 131.294220, 175.316620, 127.207640, 173.030570, 122.038470);
  ctx.bezierCurveTo(170.611240, 116.567940, 171.190930, 109.588310, 174.475590, 104.639750);
  ctx.bezierCurveTo(177.940050, 99.420325, 183.565990, 96.393721, 189.787360, 96.402430);
  ctx.bezierCurveTo(196.219340, 96.411430, 201.683780, 99.390420, 205.178830, 104.793210);
  ctx.bezierCurveTo(207.132730, 107.813630, 208.031950, 110.913350, 208.034710, 114.637780);
  ctx.bezierCurveTo(208.040710, 122.621200, 203.166770, 129.407950, 195.545590, 132.028660);
  ctx.bezierCurveTo(193.787050, 132.633370, 193.201560, 132.719410, 190.370920, 132.789150);
  ctx.bezierCurveTo(188.221880, 132.842050, 186.732250, 132.765850, 185.811230, 132.555660);
  ctx.fill();

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(241, 135, 0)';
  ctx.moveTo(107.042740, 132.404930);
  ctx.bezierCurveTo(102.467930, 131.210400, 98.683622, 128.491350, 96.110881, 124.550300);
  ctx.bezierCurveTo(91.727291, 117.835320, 92.341199, 108.981770, 97.629054, 102.655800);
  ctx.bezierCurveTo(99.544046, 100.364850, 103.094870, 98.065708, 106.244800, 97.077122);
  ctx.bezierCurveTo(108.402010, 96.400095, 112.865320, 96.212110, 115.165900, 96.701383);
  ctx.bezierCurveTo(120.639980, 97.865577, 125.353090, 101.521540, 127.870720, 106.556540);
  ctx.bezierCurveTo(133.072420, 116.959420, 127.227550, 129.524480, 115.840660, 132.418220);
  ctx.bezierCurveTo(113.405810, 133.036990, 109.440460, 133.031000, 107.042740, 132.404920);
  ctx.fill();

  return canvas.toDataURL();
}

export function happySmiley() {
  const canvas  = document.createElement("canvas");
  canvas.width  = 800;
  canvas.height = 800;
  let ctx       = canvas.getContext("2d");

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(241, 135, 0)';
  ctx.moveTo(641.278000, 627.495000);
  ctx.bezierCurveTo(625.978000, 642.796000, 609.377000, 656.447000, 591.465000, 668.460000);
  ctx.bezierCurveTo(573.543000, 680.483000, 554.535000, 690.745000, 534.442000, 699.267000);
  ctx.bezierCurveTo(514.338000, 707.788000, 493.364000, 714.342000, 471.520000, 718.930000);
  ctx.bezierCurveTo(449.665000, 723.518000, 427.165000, 725.812000, 404.008000, 725.812000);
  ctx.bezierCurveTo(380.843000, 725.812000, 358.230000, 723.518000, 336.171000, 718.930000);
  ctx.bezierCurveTo(314.101000, 714.342000, 293.127000, 707.787000, 273.248000, 699.267000);
  ctx.bezierCurveTo(253.359000, 690.746000, 234.352000, 680.484000, 216.225000, 668.460000);
  ctx.bezierCurveTo(198.088000, 656.447000, 181.589000, 642.796000, 166.739000, 627.495000);
  ctx.bezierCurveTo(151.439000, 612.205000, 137.674000, 595.603000, 125.446000, 577.682000);
  ctx.bezierCurveTo(113.208000, 559.770000, 102.833000, 540.762000, 94.313000, 520.659000);
  ctx.bezierCurveTo(85.792000, 500.565000, 79.238000, 479.592000, 74.649000, 457.736000);
  ctx.bezierCurveTo(70.061000, 435.891000, 67.767000, 413.167000, 67.767000, 389.570000);
  ctx.bezierCurveTo(67.767000, 343.259000, 76.615000, 299.775000, 94.312000, 259.137000);
  ctx.bezierCurveTo(112.009000, 218.500000, 136.035000, 182.891000, 166.411000, 152.300000);
  ctx.bezierCurveTo(196.776000, 121.719000, 232.385000, 97.683000, 273.248000, 80.201000);
  ctx.bezierCurveTo(314.101000, 62.729000, 357.687000, 53.983000, 404.008000, 53.983000);
  ctx.bezierCurveTo(450.321000, 53.983000, 493.906000, 62.729000, 534.770000, 80.201000);
  ctx.bezierCurveTo(575.623000, 97.683000, 611.231000, 121.719000, 641.607000, 152.300000);
  ctx.bezierCurveTo(671.972000, 182.891000, 695.896000, 218.500000, 713.378000, 259.137000);
  ctx.bezierCurveTo(730.851000, 299.775000, 739.596000, 343.259000, 739.596000, 389.570000);
  ctx.bezierCurveTo(739.596000, 413.167000, 737.302000, 435.891000, 732.714000, 457.736000);
  ctx.bezierCurveTo(728.126000, 479.591000, 721.674000, 500.565000, 713.378000, 520.659000);
  ctx.bezierCurveTo(705.073000, 540.763000, 694.801000, 559.770000, 682.572000, 577.682000);
  ctx.bezierCurveTo(670.333000, 595.604000, 656.569000, 612.205000, 641.278000, 627.495000);
  ctx.moveTo(200.821000, 187.693000);
  ctx.bezierCurveTo(187.272000, 200.372000, 175.033000, 214.464000, 164.116000, 229.969000);
  ctx.bezierCurveTo(153.188000, 245.485000, 143.797000, 261.983000, 135.932000, 279.455000);
  ctx.bezierCurveTo(128.067000, 296.937000, 122.055000, 315.289000, 117.907000, 334.512000);
  ctx.bezierCurveTo(113.749000, 353.745000, 111.680000, 373.624000, 111.680000, 394.158000);
  ctx.bezierCurveTo(111.680000, 433.485000, 119.218000, 470.414000, 134.293000, 504.928000);
  ctx.bezierCurveTo(149.368000, 539.451000, 169.789000, 569.602000, 195.577000, 595.379000);
  ctx.bezierCurveTo(221.354000, 621.166000, 251.505000, 641.484000, 286.028000, 656.335000);
  ctx.bezierCurveTo(320.541000, 671.194000, 357.471000, 678.620000, 396.798000, 678.620000);
  ctx.bezierCurveTo(416.892000, 678.620000, 436.554000, 676.551000, 455.788000, 672.392000);
  ctx.bezierCurveTo(475.011000, 668.245000, 493.362000, 662.346000, 510.845000, 654.696000);
  ctx.bezierCurveTo(528.317000, 647.055000, 544.816000, 637.767000, 560.331000, 626.840000);
  ctx.bezierCurveTo(575.836000, 615.923000, 590.153000, 603.469000, 603.262000, 589.480000);
  ctx.bezierCurveTo(615.491000, 576.812000, 626.418000, 563.047000, 636.034000, 548.187000);
  ctx.bezierCurveTo(645.640000, 533.337000, 653.834000, 517.709000, 660.613000, 501.323000);
  ctx.bezierCurveTo(667.383000, 484.937000, 672.513000, 467.680000, 676.016000, 449.544000);
  ctx.bezierCurveTo(679.508000, 431.417000, 681.259000, 412.951000, 681.259000, 394.159000);
  ctx.bezierCurveTo(681.259000, 354.832000, 673.823000, 317.912000, 658.974000, 283.389000);
  ctx.bezierCurveTo(644.114000, 248.876000, 623.795000, 218.725000, 598.018000, 192.938000);
  ctx.bezierCurveTo(572.231000, 167.161000, 542.080000, 146.842000, 507.567000, 131.982000);
  ctx.bezierCurveTo(473.044000, 117.132000, 436.124000, 109.697000, 396.797000, 109.697000);
  ctx.bezierCurveTo(377.564000, 109.697000, 358.996000, 111.448000, 341.084000, 114.941000);
  ctx.bezierCurveTo(323.162000, 118.443000, 305.905000, 123.574000, 289.304000, 130.344000);
  ctx.bezierCurveTo(272.693000, 137.124000, 256.962000, 145.317000, 242.112000, 154.923000);
  ctx.bezierCurveTo(227.252000, 164.540000, 213.487000, 175.242000, 200.819000, 187.040000);
  ctx.lineTo(200.819000, 187.693000);
  ctx.moveTo(256.534000, 459.702000);
  ctx.bezierCurveTo(269.202000, 486.801000, 288.426000, 508.860000, 314.213000, 525.901000);
  ctx.bezierCurveTo(339.990000, 542.943000, 368.615000, 551.464000, 400.076000, 551.464000);
  ctx.bezierCurveTo(431.967000, 551.464000, 460.807000, 542.943000, 486.594000, 525.901000);
  ctx.bezierCurveTo(512.371000, 508.860000, 531.821000, 486.575000, 544.929000, 459.047000);
  ctx.bezierCurveTo(545.359000, 457.735000, 545.799000, 456.425000, 546.240000, 455.113000);
  ctx.bezierCurveTo(546.671000, 453.802000, 546.895000, 452.492000, 546.895000, 451.180000);
  ctx.bezierCurveTo(546.895000, 445.937000, 545.032000, 441.461000, 541.325000, 437.744000);
  ctx.bezierCurveTo(537.607000, 434.036000, 533.132000, 432.173000, 527.887000, 432.173000);
  ctx.bezierCurveTo(523.954000, 432.173000, 520.350000, 433.381000, 517.073000, 435.777000);
  ctx.bezierCurveTo(513.796000, 438.184000, 511.502000, 441.348000, 510.191000, 445.281000);
  ctx.bezierCurveTo(501.885000, 465.825000, 487.579000, 482.427000, 467.259000, 495.094000);
  ctx.bezierCurveTo(446.940000, 507.773000, 424.758000, 514.102000, 400.732000, 514.102000);
  ctx.bezierCurveTo(376.255000, 514.102000, 353.868000, 507.773000, 333.549000, 495.094000);
  ctx.bezierCurveTo(313.230000, 482.426000, 298.913000, 465.824000, 290.617000, 445.281000);
  ctx.bezierCurveTo(288.866000, 442.229000, 286.459000, 439.710000, 283.408000, 437.744000);
  ctx.bezierCurveTo(280.345000, 435.777000, 277.069000, 434.794000, 273.576000, 434.794000);
  ctx.lineTo(272.921000, 434.794000);
  ctx.lineTo(266.367000, 434.794000);
  ctx.bezierCurveTo(262.865000, 436.106000, 259.915000, 438.297000, 257.518000, 441.349000);
  ctx.bezierCurveTo(255.111000, 444.412000, 253.913000, 447.904000, 253.913000, 451.836000);
  ctx.bezierCurveTo(253.913000, 453.147000, 254.128000, 454.457000, 254.568000, 455.769000);
  ctx.bezierCurveTo(254.998000, 457.080000, 255.439000, 458.175000, 255.879000, 459.046000);
  ctx.lineTo(256.534000, 459.702000);
  ctx.moveTo(347.727000, 295.720000);
  ctx.bezierCurveTo(347.727000, 322.355000, 326.135000, 343.947000, 299.500000, 343.947000);
  ctx.bezierCurveTo(272.866000, 343.947000, 251.274000, 322.355000, 251.274000, 295.720000);
  ctx.bezierCurveTo(251.274000, 269.086000, 272.866000, 247.494000, 299.500000, 247.494000);
  ctx.bezierCurveTo(326.135000, 247.494000, 347.727000, 269.085000, 347.727000, 295.720000);
  ctx.moveTo(548.727000, 295.720000);
  ctx.bezierCurveTo(548.727000, 322.355000, 527.135000, 343.947000, 500.500000, 343.947000);
  ctx.bezierCurveTo(473.865000, 343.947000, 452.273000, 322.355000, 452.273000, 295.720000);
  ctx.bezierCurveTo(452.273000, 269.086000, 473.865000, 247.494000, 500.500000, 247.494000);
  ctx.bezierCurveTo(527.135000, 247.494000, 548.727000, 269.085000, 548.727000, 295.720000);
  ctx.fill();

  return canvas.toDataURL();
}

export function overjoyedSmiley() {
  const canvas  = document.createElement("canvas");
  canvas.width  = 800;
  canvas.height = 800;
  let ctx       = canvas.getContext("2d");

  ctx.beginPath();
  ctx.lineWidth = 0.000000;
  ctx.fillStyle = 'rgb(241, 135, 0)';
  ctx.moveTo(641.278000, 627.495000);
  ctx.bezierCurveTo(625.978000, 642.796000, 609.378000, 656.447000, 591.465000, 668.460000);
  ctx.bezierCurveTo(573.543000, 680.483000, 554.534000, 690.745000, 534.442000, 699.267000);
  ctx.bezierCurveTo(514.338000, 707.788000, 493.364000, 714.342000, 471.520000, 718.930000);
  ctx.bezierCurveTo(449.665000, 723.518000, 427.165000, 725.813000, 404.008000, 725.813000);
  ctx.bezierCurveTo(380.843000, 725.813000, 358.230000, 723.518000, 336.171000, 718.930000);
  ctx.bezierCurveTo(314.101000, 714.342000, 293.127000, 707.787000, 273.248000, 699.267000);
  ctx.bezierCurveTo(253.358000, 690.746000, 234.352000, 680.485000, 216.225000, 668.460000);
  ctx.bezierCurveTo(198.088000, 656.447000, 181.589000, 642.796000, 166.739000, 627.495000);
  ctx.bezierCurveTo(151.439000, 612.205000, 137.675000, 595.602000, 125.446000, 577.682000);
  ctx.bezierCurveTo(113.209000, 559.770000, 102.834000, 540.762000, 94.313000, 520.660000);
  ctx.bezierCurveTo(85.792000, 500.566000, 79.238000, 479.593000, 74.649000, 457.737000);
  ctx.bezierCurveTo(70.061000, 435.891000, 67.767000, 413.168000, 67.767000, 389.570000);
  ctx.bezierCurveTo(67.767000, 343.259000, 76.616000, 299.775000, 94.312000, 259.137000);
  ctx.bezierCurveTo(112.009000, 218.500000, 136.036000, 182.891000, 166.412000, 152.300000);
  ctx.bezierCurveTo(196.776000, 121.719000, 232.386000, 97.683000, 273.249000, 80.201000);
  ctx.bezierCurveTo(314.102000, 62.729000, 357.687000, 53.983000, 404.009000, 53.983000);
  ctx.bezierCurveTo(450.322000, 53.983000, 493.906000, 62.729000, 534.771000, 80.201000);
  ctx.bezierCurveTo(575.625000, 97.683000, 611.232000, 121.719000, 641.608000, 152.300000);
  ctx.bezierCurveTo(671.973000, 182.891000, 695.897000, 218.500000, 713.379000, 259.137000);
  ctx.bezierCurveTo(730.852000, 299.775000, 739.597000, 343.259000, 739.597000, 389.570000);
  ctx.bezierCurveTo(739.597000, 413.167000, 737.303000, 435.891000, 732.715000, 457.737000);
  ctx.bezierCurveTo(728.126000, 479.591000, 721.675000, 500.566000, 713.379000, 520.660000);
  ctx.bezierCurveTo(705.073000, 540.764000, 694.802000, 559.770000, 682.572000, 577.682000);
  ctx.bezierCurveTo(670.332000, 595.604000, 656.569000, 612.205000, 641.278000, 627.495000);
  ctx.moveTo(200.821000, 187.693000);
  ctx.bezierCurveTo(187.272000, 200.372000, 175.034000, 214.464000, 164.117000, 229.969000);
  ctx.bezierCurveTo(153.188000, 245.485000, 143.798000, 261.983000, 135.932000, 279.455000);
  ctx.bezierCurveTo(128.067000, 296.937000, 122.055000, 315.289000, 117.907000, 334.512000);
  ctx.bezierCurveTo(113.750000, 353.745000, 111.680000, 373.624000, 111.680000, 394.158000);
  ctx.bezierCurveTo(111.680000, 433.485000, 119.218000, 470.414000, 134.293000, 504.928000);
  ctx.bezierCurveTo(149.368000, 539.451000, 169.789000, 569.602000, 195.577000, 595.379000);
  ctx.bezierCurveTo(221.353000, 621.166000, 251.505000, 641.484000, 286.027000, 656.335000);
  ctx.bezierCurveTo(320.540000, 671.194000, 357.470000, 678.620000, 396.798000, 678.620000);
  ctx.bezierCurveTo(416.892000, 678.620000, 436.554000, 676.551000, 455.787000, 672.391000);
  ctx.bezierCurveTo(475.011000, 668.245000, 493.361000, 662.345000, 510.845000, 654.696000);
  ctx.bezierCurveTo(528.317000, 647.054000, 544.816000, 637.766000, 560.330000, 626.840000);
  ctx.bezierCurveTo(575.836000, 615.923000, 590.152000, 603.469000, 603.262000, 589.480000);
  ctx.bezierCurveTo(615.491000, 576.812000, 626.418000, 563.047000, 636.033000, 548.187000);
  ctx.bezierCurveTo(645.639000, 533.337000, 653.833000, 517.709000, 660.612000, 501.324000);
  ctx.bezierCurveTo(667.383000, 484.937000, 672.512000, 467.680000, 676.015000, 449.545000);
  ctx.bezierCurveTo(679.507000, 431.418000, 681.258000, 412.952000, 681.258000, 394.160000);
  ctx.bezierCurveTo(681.258000, 354.833000, 673.821000, 317.913000, 658.973000, 283.390000);
  ctx.bezierCurveTo(644.113000, 248.877000, 623.794000, 218.726000, 598.017000, 192.939000);
  ctx.bezierCurveTo(572.230000, 167.162000, 542.079000, 146.843000, 507.566000, 131.983000);
  ctx.bezierCurveTo(473.043000, 117.133000, 436.123000, 109.698000, 396.796000, 109.698000);
  ctx.bezierCurveTo(377.563000, 109.698000, 358.994000, 111.449000, 341.082000, 114.942000);
  ctx.bezierCurveTo(323.160000, 118.444000, 305.903000, 123.575000, 289.303000, 130.345000);
  ctx.bezierCurveTo(272.692000, 137.125000, 256.961000, 145.318000, 242.111000, 154.924000);
  ctx.bezierCurveTo(227.252000, 164.541000, 213.486000, 175.243000, 200.818000, 187.041000);
  ctx.lineTo(200.818000, 187.694000);
  ctx.lineTo(200.821000, 187.694000);
  ctx.moveTo(256.130000, 467.925000);
  ctx.bezierCurveTo(268.798000, 499.769000, 288.022000, 525.692000, 313.809000, 545.715000);
  ctx.bezierCurveTo(339.586000, 565.740000, 368.211000, 575.753000, 399.672000, 575.753000);
  ctx.bezierCurveTo(431.563000, 575.753000, 460.402000, 565.740000, 486.190000, 545.715000);
  ctx.bezierCurveTo(511.967000, 525.692000, 531.418000, 499.503000, 544.525000, 467.155000);
  ctx.bezierCurveTo(544.955000, 465.614000, 545.395000, 464.074000, 545.837000, 462.533000);
  ctx.bezierCurveTo(546.268000, 460.993000, 546.491000, 459.453000, 546.491000, 457.912000);
  ctx.bezierCurveTo(546.491000, 451.751000, 544.629000, 446.491000, 540.922000, 442.124000);
  ctx.bezierCurveTo(537.203000, 437.767000, 532.729000, 435.577000, 527.484000, 435.577000);
  ctx.bezierCurveTo(523.551000, 435.577000, 265.963000, 438.657000, 265.963000, 438.657000);
  ctx.bezierCurveTo(262.461000, 440.198000, 259.511000, 442.773000, 257.113000, 446.359000);
  ctx.bezierCurveTo(254.707000, 449.958000, 253.509000, 454.060000, 253.509000, 458.681000);
  ctx.bezierCurveTo(253.509000, 460.221000, 253.724000, 461.761000, 254.164000, 463.302000);
  ctx.bezierCurveTo(254.594000, 464.842000, 255.035000, 466.130000, 255.475000, 467.155000);
  ctx.lineTo(256.130000, 467.925000);
  ctx.moveTo(266.366000, 318.126000);
  ctx.bezierCurveTo(266.796000, 321.628000, 267.891000, 324.793000, 269.642000, 327.630000);
  ctx.bezierCurveTo(271.383000, 330.477000, 273.576000, 332.986000, 276.197000, 335.168000);
  ctx.bezierCurveTo(276.628000, 335.168000, 277.068000, 335.168000, 277.509000, 335.168000);
  ctx.bezierCurveTo(281.872000, 335.168000, 285.702000, 333.529000, 288.979000, 330.252000);
  ctx.bezierCurveTo(292.256000, 326.975000, 293.895000, 323.155000, 293.895000, 318.782000);
  ctx.lineTo(293.895000, 318.127000);
  ctx.bezierCurveTo(293.895000, 311.142000, 296.189000, 305.346000, 300.777000, 300.757000);
  ctx.bezierCurveTo(305.365000, 296.169000, 311.152000, 293.875000, 318.146000, 293.875000);
  ctx.bezierCurveTo(324.701000, 293.875000, 330.271000, 296.169000, 334.860000, 300.757000);
  ctx.bezierCurveTo(339.448000, 305.345000, 341.742000, 311.142000, 341.742000, 318.127000);
  ctx.bezierCurveTo(342.173000, 322.500000, 344.036000, 326.217000, 347.313000, 329.269000);
  ctx.bezierCurveTo(350.590000, 332.332000, 354.626000, 333.857000, 359.439000, 333.857000);
  ctx.bezierCurveTo(363.802000, 333.857000, 367.632000, 332.331000, 370.909000, 329.269000);
  ctx.bezierCurveTo(374.186000, 326.217000, 376.040000, 322.499000, 376.480000, 318.127000);
  ctx.bezierCurveTo(376.480000, 317.697000, 376.480000, 317.256000, 376.480000, 316.816000);
  ctx.bezierCurveTo(376.480000, 316.386000, 376.480000, 315.945000, 376.480000, 315.505000);
  ctx.bezierCurveTo(376.480000, 300.215000, 371.124000, 287.218000, 360.421000, 276.506000);
  ctx.bezierCurveTo(349.709000, 265.804000, 336.713000, 260.447000, 321.422000, 260.447000);
  ctx.bezierCurveTo(306.120000, 260.447000, 293.125000, 265.802000, 282.423000, 276.506000);
  ctx.bezierCurveTo(271.711000, 287.218000, 266.364000, 300.214000, 266.364000, 315.505000);
  ctx.bezierCurveTo(266.364000, 315.945000, 266.364000, 316.386000, 266.364000, 316.816000);
  ctx.bezierCurveTo(266.366000, 317.256000, 266.366000, 317.696000, 266.366000, 318.126000);
  ctx.moveTo(438.092000, 318.126000);
  ctx.bezierCurveTo(438.092000, 321.188000, 439.832000, 324.465000, 443.335000, 327.958000);
  ctx.bezierCurveTo(446.826000, 331.460000, 448.577000, 333.857000, 448.577000, 335.168000);
  ctx.bezierCurveTo(449.009000, 335.168000, 449.448000, 335.168000, 449.890000, 335.168000);
  ctx.bezierCurveTo(454.252000, 335.168000, 457.970000, 333.529000, 461.033000, 330.252000);
  ctx.bezierCurveTo(464.086000, 326.975000, 465.622000, 323.155000, 465.622000, 318.782000);
  ctx.lineTo(465.622000, 318.127000);
  ctx.bezierCurveTo(465.622000, 311.142000, 468.018000, 305.346000, 472.831000, 300.757000);
  ctx.bezierCurveTo(477.635000, 296.169000, 483.317000, 293.875000, 489.872000, 293.875000);
  ctx.bezierCurveTo(496.428000, 293.875000, 502.101000, 296.169000, 506.915000, 300.757000);
  ctx.bezierCurveTo(511.719000, 305.345000, 514.125000, 310.917000, 514.125000, 317.471000);
  ctx.bezierCurveTo(514.125000, 317.911000, 514.125000, 318.352000, 514.125000, 318.782000);
  ctx.bezierCurveTo(514.125000, 323.595000, 515.764000, 327.743000, 519.041000, 331.236000);
  ctx.bezierCurveTo(522.317000, 334.738000, 526.353000, 336.479000, 531.166000, 336.479000);
  ctx.bezierCurveTo(535.970000, 336.479000, 540.015000, 334.738000, 543.292000, 331.236000);
  ctx.bezierCurveTo(546.568000, 327.743000, 548.208000, 323.596000, 548.208000, 318.782000);
  ctx.lineTo(548.208000, 318.127000);
  ctx.bezierCurveTo(548.208000, 317.697000, 548.208000, 317.256000, 548.208000, 316.816000);
  ctx.bezierCurveTo(548.208000, 316.386000, 548.208000, 315.945000, 548.208000, 315.505000);
  ctx.bezierCurveTo(548.208000, 300.215000, 542.852000, 287.218000, 532.148000, 276.506000);
  ctx.bezierCurveTo(521.436000, 265.804000, 508.440000, 260.447000, 493.149000, 260.447000);
  ctx.bezierCurveTo(477.848000, 260.447000, 464.852000, 265.802000, 454.151000, 276.506000);
  ctx.bezierCurveTo(443.438000, 287.218000, 438.092000, 300.214000, 438.092000, 315.505000);
  ctx.bezierCurveTo(438.092000, 315.945000, 438.092000, 316.386000, 438.092000, 316.816000);
  ctx.bezierCurveTo(438.092000, 317.256000, 438.092000, 317.696000, 438.092000, 318.126000);
  ctx.moveTo(312.802000, 464.312000);
  ctx.bezierCurveTo(312.802000, 464.312000, 501.207000, 463.806000, 501.827000, 463.807000);
  ctx.bezierCurveTo(517.163000, 463.832000, 500.498000, 483.676000, 496.919000, 488.078000);
  ctx.bezierCurveTo(488.232000, 498.760000, 480.000000, 510.327000, 469.737000, 519.586000);
  ctx.bezierCurveTo(455.440000, 532.486000, 437.742000, 543.265000, 419.058000, 548.236000);
  ctx.bezierCurveTo(381.071000, 558.340000, 344.694000, 534.439000, 319.530000, 508.261000);
  ctx.bezierCurveTo(312.444000, 500.890000, 305.344000, 492.760000, 299.691000, 484.218000);
  ctx.bezierCurveTo(296.237000, 478.997000, 290.164000, 463.597000, 302.247000, 464.934000);
  ctx.fill();

  return canvas.toDataURL();
}



// WEBPACK FOOTER //
// ./assets/javascripts/datas/_icons_canvas.js